import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BadRequestComponent } from './bad-request/bad-request.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { InternalServerErrorComponent } from './internal-server-error/internal-server-error.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { TimeoutComponent } from './timeout/timeout.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'bad-request', component: BadRequestComponent },
      { path: 'forbidden', component: ForbiddenComponent },
      { path: 'internal-server-error', component: InternalServerErrorComponent },
      { path: 'not-found', component: NotFoundComponent },
      { path: 'timeout-error', component: TimeoutComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ErrorsRoutingModule {}
